module.exports = __webpack_public_path__ + "img/doc-with-checkmark.734993ad.svg";